// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__3Zzm4","control":"Checkout_control__wQGII","actions":"Checkout_actions__FV-CD","submit":"Checkout_submit__1bdI4","invalid":"Checkout_invalid__3xYv5"};